/* eslint-disable */
import messageTypes from '@ringcentral-integration/commons/enums/messageTypes';
export default {
  addLog: 'Protokoll',
  editLog: 'Protokoll bearbeiten',
  viewDetails: 'Details anzeigen',
  addEntity: 'Neu erstellen',
  call: 'Anruf',
  text: 'Text',
  conversation: 'Konversation',
  groupConversation: 'Gruppenkonversation',
  voiceMessage: 'Sprachnachricht',
  [messageTypes.voiceMail]: 'Voicemail',
  [messageTypes.fax]: 'Fax',
  mark: 'Als ungelesen markieren',
  unmark: 'Als gelesen markieren',
  delete: 'Löschen',
  faxSent: 'Fax gesendet',
  faxReceived: 'Fax erhalten',
  pages: 'Seiten',
  page: 'Seite',
  preview: 'Anzeigen',
  download: 'Herunterladen',
  mmsWithOneAttachment: 'MMS mit 1 Anhang',
  mmsWithAttachments: 'MMS mit {count} Anhängen',
} as const;

// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"conversation"@#@ @source: @#@"Conversation"@#@
// @key: @#@"groupConversation"@#@ @source: @#@"Group Conversation"@#@
// @key: @#@"voiceMessage"@#@ @source: @#@"Voice message"@#@
// @key: @#@"[messageTypes.voiceMail]"@#@ @source: @#@"Voice Mail"@#@
// @key: @#@"[messageTypes.fax]"@#@ @source: @#@"Fax"@#@
// @key: @#@"mark"@#@ @source: @#@"Mark as Unread"@#@
// @key: @#@"unmark"@#@ @source: @#@"Mark as Read"@#@
// @key: @#@"delete"@#@ @source: @#@"Delete"@#@
// @key: @#@"faxSent"@#@ @source: @#@"Fax sent"@#@
// @key: @#@"faxReceived"@#@ @source: @#@"Fax received"@#@
// @key: @#@"pages"@#@ @source: @#@"pages"@#@
// @key: @#@"page"@#@ @source: @#@"page"@#@
// @key: @#@"preview"@#@ @source: @#@"View"@#@
// @key: @#@"download"@#@ @source: @#@"Download"@#@
// @key: @#@"mmsWithOneAttachment"@#@ @source: @#@"MMS with 1 attachment"@#@
// @key: @#@"mmsWithAttachments"@#@ @source: @#@"MMS with {count} attachments"@#@
